import { render } from "./NoResult.vue?vue&type=template&id=7841df97&scoped=true"
const script = {}

import "./NoResult.vue?vue&type=style&index=0&id=7841df97&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7841df97"]])

export default __exports__